import Api from "@services/api";

export const getNotfoundAttrs = async () => {
  const res = await Api().get("/notfound?populate=deep");

  return res.data;
};
